import { render, staticRenderFns } from "./ServiceAttachments.vue?vue&type=template&id=710acb2e&scoped=true"
import script from "./ServiceAttachments.vue?vue&type=script&lang=js"
export * from "./ServiceAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710acb2e",
  null
  
)

export default component.exports